import url from "url2"; // todo: use browser new URL

import guid from "./guid";

// todo: remove
import fetchPolyfill from "./fetch-polyfill";

const shoppingSession = guid();

export default function sendLog(data) {
    const merged = Object.assign({
        s    : window.native.stats.sessionId,
        gems : window.native.stats.gems,
        shoppingSession
    }, data);

    // Only send what's needed - server will provide appropriate defaults
    Object.entries(merged).forEach(([ key, val ]) => {
        if (val === undefined || val === null) {
            delete merged[key];
        }
    });

    /* program:!live */
    // Do some stupid shit so release mode doesn't strip this log
    if (localStorage.showLogs) {
        window.console.log("Event Log: ", merged);
    }
    /* /program:!live */

    return fetchPolyfill(url.format({
        path     : "/log",
        queryKey : merged
    }));
}
